import React, { useState } from 'react';
import { SpinRoulette } from './../../../utilities/BL/Roulette';

const Roulette = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const screenId = parseInt(queryParams.get('screenId') || 1, 10);

    const [isSpinning, setIsSpinning] = useState(false);
    const [toast, setToast] = useState('');

    const showToast = (msg) => {
        setToast(msg);
        setTimeout(() => setToast(''), 3000);
    };

    const handleSpinClick = async () => {
        if (isSpinning) return;
        setIsSpinning(true);
        showToast('¡Girando la ruleta! Mira la pantalla grande... 🎡');

        try {
            // Mandamos el tiro directamente con un nombre por defecto
            await SpinRoulette({
                targetScreenId: screenId,
                playerName: "Aficionado",
                playerContact: ""
            });

            // Bloqueamos el botón por 7 segundos en lo que la ruleta física termina de girar
            setTimeout(() => {
                setIsSpinning(false);
                showToast('¡Listo para intentar de nuevo!');
            }, 7000);

        } catch (error) {
            showToast('❌ Error de conexión al girar');
            setIsSpinning(false);
        }
    };

    return (
        <>
            <div className='SelfieFan__Screen__QR__Background'>
                <img 
                    //src='/img/selfiefan/Fondo-SelfieFan-Varonil-s2-1.png'
                    src='/img/selfiefan/Fondo-SelfieFan-Femenil.png'
                    className='SelfieFan__Screen__QR__Background__Video'
                    alt="Background"
                    style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                />
            </div>

            <div style={{ position: 'relative', width: '100vw', height: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', padding: '40px 20px', zIndex: 1 }}>
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <img src="/img/page/adsl-five.png" alt="ADSL Logo" style={{ maxWidth: '180px', marginBottom: '10px' }} />
                    <p style={{ margin: 0, color: '#fff', fontSize: '1.1rem', fontWeight: '500' }}>Conectado a la Pantalla #{screenId}</p>
                </div>

                {/* BOTÓN CENTRAL DE DISPARO INTERACTIVO ESTILO CASINO */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <button 
                        disabled={isSpinning}
                        onClick={handleSpinClick}
                        style={{
                            width: '200px', height: '200px', borderRadius: '50%',
                            background: isSpinning ? '#444' : 'linear-gradient(135deg, #1e246a, #091277)',
                            border: '10px solid #ffffff', color: '#fff',
                            fontSize: '2rem', fontWeight: '900', textTransform: 'uppercase',
                            //</div>boxShadow: isSpinning ? 'none' : '0 15px 35px rgba(220,38,38,0.4), inset 0 4px 10px rgba(255,255,255,0.4)',
                            boxShadow: isSpinning ? 'none' : '0 15px 35px rgba(9,18,119,0.4), inset 0 4px 10px rgba(255,255,255,0.4)',
                            cursor: isSpinning ? 'not-allowed' : 'pointer', 
                            transform: isSpinning ? 'translateY(4px)' : 'none',
                            transition: 'all 0.15s ease', display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center'
                        }}
                    >
                        {isSpinning ? '🎡' : '¡GIRAR!'}
                    </button>
                    <p style={{ color: '#fff', marginTop: '30px', fontSize: '1.2rem', textAlign: 'center', opacity: 0.8, textShadow: '0 2px 4px rgba(0,0,0,0.5)' }}>
                        {isSpinning ? 'La ruleta está girando en la pantalla...' : '¡Toca el botón para jugar!'}
                    </p>
                </div>

                <p style={{ color: '#fff', fontSize: '1.5em', margin: 0 }}>Hecho con ♥ por Interaktia | 2026</p>
                
                {toast && (
                    <div style={{ 
                        position: 'fixed', 
                        bottom: '40px', 
                        backgroundColor: 'rgba(0,0,0,0.9)', 
                        color: 'white', 
                        padding: '12px 25px', 
                        borderRadius: '30px', 
                        zIndex: 2000, 
                        border: '1px solid #1e246a',
                        boxShadow: '0 4px 15px rgba(0,0,0,0.5)'
                    }}>
                        {toast}
                    </div>
                )}
            </div>
        </>
    );
};

export { Roulette };
